import React from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import historyComponent from '../hoc/historyComponent';
import {BASE_URL_TYPE} from '../../api/axios';

const siteUrl = BASE_URL_TYPE.PROPZONE;

const propTypes = {
  isFront: PropTypes.func.isRequired,
};

const Logo = (props) => {
  // Get redux states.
  const {menuCollapsed} = useSelector(state => ({
    menuCollapsed: state.ui.menuCollapsed,
  }), shallowEqual);
  const {isFront} = props;
  const title = 'PropZone';
  const logoSrc = `${siteUrl}/themes/custom/gridics/logo.svg?v1`;
  const logoFulSrc = `${siteUrl}/themes/custom/gridics/images/logo-full.svg`;
  const logoElement = (
    <a href="/">
      {menuCollapsed && <img src={logoSrc} title={title} alt={title} width="20" height="20" />}
      {!menuCollapsed && <img className="full" src={logoFulSrc} alt={title} title={title} width="144" height="30" />}
    </a>
  );
  return <div className={classnames('logo', {front: isFront()})}>{logoElement}</div>;
};

Logo.propTypes = propTypes;

export default historyComponent(Logo);
